import type { ComponentProps, ReactNode } from 'react'
import { HugeiconsIcon, type IconSvgElement } from '@hugeicons/react'
import { cn } from '../lib/utils'

export function GlowCard({
  className,
  children,
  ...props
}: ComponentProps<'section'>) {
  return (
    <section
      className={cn(
        'group/card relative overflow-hidden rounded-[28px] bg-elevated text-foreground',
        className,
      )}
      {...props}
    >
      {children}
    </section>
  )
}

export function Bubbles({ children }: { children: ReactNode }) {
  return <div className="flex shrink-0 items-center">{children}</div>
}

export function Bubble({
  icon,
  image,
  label,
  className,
}: {
  icon?: IconSvgElement
  image?: string | null
  label?: string
  className?: string
}) {
  return (
    <span
      title={label}
      className={cn(
        '-ml-2 flex size-10 shrink-0 items-center justify-center overflow-hidden rounded-full bg-paper text-paper-foreground shadow-[0_6px_16px_-8px_rgb(0_0_0/0.45)] ring-[3px] ring-elevated transition-[margin] duration-300 ease-out group-hover/card:-ml-0.5 first:ml-0 group-hover/card:first:ml-0',
        className,
      )}
    >
      {image ? (
        <img
          src={image}
          alt=""
          referrerPolicy="no-referrer"
          className="size-full object-cover"
        />
      ) : icon ? (
        <HugeiconsIcon icon={icon} strokeWidth={1.8} className="size-[18px]" />
      ) : (
        <span className="text-xs font-semibold uppercase">
          {label?.replace(/^@/, '').slice(0, 2)}
        </span>
      )}
    </span>
  )
}
